import type {Component} from 'typings/portaro.fe.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type RecordService from '../record.service';

export interface KpRecordHoldingCreationButtonBindings {
    cssClass?: string;
}

class KpRecordHoldingCreationButtonController implements KpRecordHoldingCreationButtonBindings {
    public cssClass: string;

    /*@ngInject*/
    constructor(private recordService: RecordService) {
    }

    @ngAsync()
    public async createRecordHolding(): Promise<void> {
        await this.recordService.createRecordHoldingAndAddExemplarsThrowingToModal(null);
    }
}

/**
 * @ngdoc component
 * @name kpRecordHoldingCreationButton
 * @module portaro.components
 *
 * @param {string=} cssClass bootstrap button type
 *
 * @description
 * This component is button which calls API according to input parameters of
 *
 */
export default class KpRecordHoldingCreationButtonComponent implements Component<KpRecordHoldingCreationButtonBindings> {
    public static readonly componentName = 'kpRecordHoldingCreationButton';

    public template = '<button type="button" class="{{$ctrl.cssClass || \'btn btn-primary btn-sm\'}}" ng-click="$ctrl.createRecordHolding()" ng-transclude></button>';
    public transclude = true;

    public bindings = {
        cssClass: '@?',
    } as const;

    public controller = KpRecordHoldingCreationButtonController;
}
